  import React, { useState } from 'react';
  import { BrowserRouter, Switch } from 'react-router-dom';
  import { ConfigProvider, Switch as AntSwitch, theme } from 'antd';
  import { Provider } from 'react-redux';
  import 'intersection-observer';

  import enGB from 'antd/es/locale/en_GB';
  import moment from 'moment';
  import 'moment/locale/en-gb';

  import 'video-react/dist/video-react.css';
  import styled from 'styled-components';

  import Layout from './components/Layout';
  import { Login, authenticatedRoutes } from './routes';

  import './fontAwesome.js';
  import { store } from './reducers/store';
  import { setDarkThemeAndStore } from './actions/darkTheme'; // Import your action creator

  moment.updateLocale('en-GB');

  const StyledAntSwitch = styled(AntSwitch)`
    // Your custom styles here
    // For example:
    position: absolute;
    top: 22px;
    right: 200px;
    .ant-switch-inner {
      background-color: ${({ isDarkTheme }) => (isDarkTheme ? '#555' : '#ddd')};
    }
  `;

  const App = () => {
      const storedTheme = localStorage.getItem('wf_dark_theme');
      const initialTheme = !storedTheme || storedTheme === 'false' ? false : true;
      const [isDarkTheme, setIsDarkTheme] = useState(initialTheme);
      store.dispatch(setDarkThemeAndStore(initialTheme));

      const toggleTheme = () => {
          const newTheme = !isDarkTheme;
          setIsDarkTheme(newTheme);
          localStorage.setItem('wf_dark_theme', newTheme.toString());
          store.dispatch(setDarkThemeAndStore(newTheme));
      };

      return (
          <Provider store={store}>
              <ConfigProvider
                  locale={enGB}
                  theme={{ algorithm: isDarkTheme ? theme.darkAlgorithm : theme.defaultAlgorithm }}
              >
                  <BrowserRouter>
                      <Layout isDarkTheme={isDarkTheme}>
                          <Switch>
                              {authenticatedRoutes}
                              <Login />
                          </Switch>
                      </Layout>
                  </BrowserRouter>
              </ConfigProvider>
              <StyledAntSwitch
                  checked={isDarkTheme}
                  onChange={toggleTheme}
                  checkedChildren="Dark"
                  unCheckedChildren="Light"
                  isDarkTheme={isDarkTheme}
              />
          </Provider>
      );
  };

  export default App;
